module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CompareInfo":{"titleScreenReader":"Porovnání parametrů produktů"}}}')
  delete Component.options._Ctor
}
